import { render, staticRenderFns } from "./textarea-box.vue?vue&type=template&id=7346eb44&scoped=true&"
import script from "./textarea-box.vue?vue&type=script&lang=js&"
export * from "./textarea-box.vue?vue&type=script&lang=js&"
import style0 from "./textarea-box.vue?vue&type=style&index=0&id=7346eb44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7346eb44",
  null
  
)

export default component.exports